import { Injectable } from '@nestjs/common';
import { TypesDTO } from './types.dto';
import { Types } from '../types.entity';

@Injectable()
export class TypesAdapter {
    public convertDtoToEntity(typesDto: TypesDTO, isUpdate: boolean = false): Types {
        const types = new Types();
        types.typeId = typesDto.typeId;
        types.type = typesDto.type;
        types.itemSubCategoryId = typesDto.itemSubCategoryId
        types.isActive = typesDto.isActive == undefined ? true : typesDto.isActive;
        if (isUpdate) {
            types.updatedUser = typesDto.updatedUser;
        } else {
            types.isActive = true;
            types.createdUser = typesDto.createdUser;
        }
        return types;
    }

    public convertEntityToDto(notifyPartyObject:Types):TypesDTO{
        const notifyPartyDto = new TypesDTO;
        notifyPartyDto.typeId = notifyPartyObject.typeId;
        notifyPartyDto.type = notifyPartyObject.type;
        notifyPartyDto.itemSubCategoryId = notifyPartyObject.itemSubCategoryId;
        notifyPartyDto.isActive=notifyPartyObject.isActive;
        notifyPartyDto.createdAt=notifyPartyObject.createdAt;
        notifyPartyDto.updatedAt=notifyPartyObject.updatedAt;
        notifyPartyDto.createdUser=notifyPartyObject.createdUser;
        notifyPartyDto.updatedUser=notifyPartyObject.updatedUser;
        notifyPartyDto.versionFlag=notifyPartyObject.versionFlag;
        return notifyPartyDto;
    }

}